import { render, staticRenderFns } from "./UploadBankLogo.vue?vue&type=template&id=64da11a7&"
import script from "./UploadBankLogo.vue?vue&type=script&lang=js&"
export * from "./UploadBankLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports